module.exports = __webpack_public_path__ + "static/media/health_2.91a8af9b.svg";